import api from 'api';

const profileManager = {
    getProfile() {
        return api.profile.getProfile();
    },
};

export default profileManager;
